import React, { useEffect, useState } from "react";
import { MapContainer, Marker, TileLayer } from "react-leaflet";
import CustomButton from "../../components/CustomButton";
import toaster from "../../utils/toaster";
import Loading from "./../../assets/images/loading.svg";
import LOGO from "./../../assets/images/snapdc_logo.png";
const SamplingDone = (props) => {
  const [data, setData] = useState({
    order: {},
    waiting: true,
  });
  const [submit, setSubmit] = useState({
    result: {},
    waiting: false,
  });
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    let id = params.get("id");
    fetch(
      "https://core.snapp.doctor/Api/MdsService/v1/getMdsOrderForSampler/" + id
    )
      .then((response) => response.json())
      .then((json_response) => {
        setData({
          order: json_response.order,
          waiting: false,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  const samplingDoneSubmit = () => {
    const params = new URLSearchParams(window.location.search);
    let id = params.get("id");
    setSubmit((prevState) => ({
      ...prevState,
      waiting: true,
    }));
    fetch(
      "https://core.snapp.doctor/Api/MdsService/v1/mdsOrderSamplingDone/" + id
    )
      .then((response) => response.json())
      .then((json_response) => {
        toaster.success("وضعیت سفارش با موفقیت بروزرسانی شد!");
        setInterval(() => {
          setSubmit((prevState) => ({
            ...prevState,
            waiting: false,
          }));
          window.location.reload();
        }, 2000);
      })
      .catch((error) => {
        toaster.error("مشکلی برای سرور رخ داده است");
        setInterval(() => {
          setSubmit((prevState) => ({
            ...prevState,
            waiting: false,
          }));
          window.location.reload();
        }, 2000);
      });
  };
  const renderOrderData = () => {
    return (
      <div className="inner-data-holder">
        <div className="order-data-items">
          <div className="order-data-item">
            <div className="title">کد سفارش :</div>
            <div className="value">{data.order.id}</div>
          </div>
          <div className="order-data-item">
            <div className="title">نام مشتری :</div>
            <div className="value">{data.order.customer_contact_name}</div>
          </div>
          <div className="order-data-item">
            <div className="title">شماره تماس مشتری :</div>
            <div className="value">{data.order.customer_contact_phone}</div>
          </div>
          <div className="order-data-item">
            <div className="title">آدرس مشتری :</div>
            <div className="value">{data.order.address}</div>
          </div>
          <div className="order-data-item">
            <div className="title">
              {data.order.meta_data.sampler_name.title}
            </div>
            <div className="value">
              {data.order.meta_data.sampler_name.value}
            </div>
          </div>
          <div className="order-data-item">
            {" "}
            ‌
            <div className="title">
              {data.order.order_type === "lab"
                ? "تاریخ نمونه‌گیری :‌ "
                : "تاریخ اعزام پزشک/پرستار :"}
            </div>
            <div className="value">{renderTimes()}</div>
          </div>
        </div>
        {renderMap()}
        <div className="actions">{renderActionButton()}</div>
      </div>
    );
  };
  const renderActionButton = () => {
    const { status, sub_status, order_type } = data.order;
    if (status === "pending" && sub_status === "waiting_for_sampling") {
      return (
        <CustomButton
          action={() => samplingDoneSubmit()}
          loading={submit.waiting}
          content={
            order_type === "lab" ? "آزمایش انجام شد" : "خدمات پزشکی انجام شد"
          }
          type="success"
          block={true}
          textWhite={true}
        />
      );
    } else if (
      (status === "pending" && sub_status === "waiting_for_result") ||
      status === "done"
    ) {
      return (
        <div className="done-before">
          وضعیت این سفارش قبلا بروزرسانی شده است.
        </div>
      );
    } else {
      return (
        <div className="done-before">این سفارش آماده تغییر وضعیت نیست</div>
      );
    }
  };
  const renderTimes = () => {
    let str = "";
    str += data.order.meta_data.sampling_date.value;
    str += " - ";
    str +=
      data.order.meta_data.sampling_from_hour.title +
      " : " +
      data.order.meta_data.sampling_from_hour.value;
    str += " ";
    str +=
      data.order.meta_data.sampling_to_hour.title +
      " : " +
      data.order.meta_data.sampling_to_hour.value;
    return str;
  };
  const renderMap = () => {
    const { latitude, longitude } = data.order;
    let position = [latitude, longitude];
    if (latitude !== null && longitude !== null) {
      return (
        <div className="map-holder">
          <MapContainer
            center={position}
            zoom={15}
            scrollWheelZoom={true}
            style={{ width: "100%", height: "100%" }}
          >
            <TileLayer
              attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> SnappDoctor'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Marker position={position}></Marker>
          </MapContainer>
        </div>
      );
    }
    return null;
  };
  return (
    <div className="row justify-content-center align-items-center">
      <div className="col-lg-6 col-md-6 col-sm-12 sampling-done-holder">
        <img src={LOGO} alt="" width={150} />
        {data.waiting ? <img src={Loading} width={50} /> : renderOrderData()}
      </div>
    </div>
  );
};

export default SamplingDone;
